var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof portalAccountCopyLib_v3_2_1 !== "undefined") return resolve();
	__webpack_require__.l("https://festatic.playgami.scopely.com/portal-account-copy-lib/v3_2_1/remoteEntry.js", (event) => {
		if(typeof portalAccountCopyLib_v3_2_1 !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "portalAccountCopyLib_v3_2_1");
}).then(() => (portalAccountCopyLib_v3_2_1));